var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"overflow":"hidden"}},[_c('div',{staticClass:"pcBox"},[_c('home-header',{attrs:{"index":"1","topColorW":_vm.topColorW}}),_c('home-main',{on:{"changeTop":_vm.changeTop}}),_c('home-foot')],1),_c('div',{staticClass:"mobileBox"},[_c('mobile-main',{attrs:{"index":_vm.pageindex}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }